<template>
  <div class="rewards">
    <div class="rewards-coin">
      <!-- <i class="fa fa-angle-left" aria-hidden="true" @click="windowToUrl('/cardano-rewards-01')" v-if="last_id > 0"></i> -->
      <span>{{title}}</span>
      <i class="fa fa-angle-right" aria-hidden="true" @click="windowToUrl('/solana-staking-rewards-02')" v-if="next_id > 0"></i>
    </div>
    <div class="rewards-scroll">
      <div class="rewards-coin-btn">
        <p v-if="!loadingShow">{{time}}</p>
        <span @click="guideShow = true">Rules</span>
      </div>
      <pageloading style="margin: 100px 0;" v-if="loadingShow"></pageloading>
      <div class="rewards-list" v-if="!loadingShow">
        <div class="rewards-list-header">
          <div>#</div>
          <div>Epoch</div>
          <div>Staking Address</div>
          <div>Rewards Address</div>
          <div class="rewards-point-model-tip">
            <p>
              <span>Live Staking</span>
              <img src="../../static/images/contest/i.png" alt="" @click.stop="pointTipShow = !pointTipShow">
            </p>
            <div class="rewards-point-model-tip-content" v-if="pointTipShow">The current state of delegated SOL to PoS Node. It will be active after 1 epoch. (2~3 days).</div>
          </div>
          <div>Active Staking</div>
          <div>Prize (SOL)</div>
        </div>
        <ul>
          <li v-for="(item, index) in rewradsList" :key="index">
            <div>{{item.rank}}</div>
            <div>{{item.epoch}}</div>
            <div><a :href="item.staking_address_link" target="_blank">{{item.staking_address}}</a></div>
            <div><a :href="item.rewards_address_link" target="_blank">{{item.rewards_address}}</a></div>
            <div>{{item.live_staking}}</div>
            <div>{{item.active_staking}}</div>
            <div class="rewards-prize-link">
              <span>{{item.prize}}</span>
              <img src="../../static/images/svg/link.svg" alt="" :title="item.grant_txid" @click="windowOpen(item.grant_txlink)" v-if="item.grant_status == 1">
            </div>
          </li>
        </ul>
      </div>
    </div>

    <div class="rewards-guide-model" v-if="guideShow">
      <div class="rewards-guide-model-box">
        <div class="rewards-guide-model-header">
          <span @click="guideShow = false">✕</span>
        </div>
        <h4>Rules</h4>
        <div class="rewards-guide-model-msg">
          <div><b>●</b> <p>Staking your Solana to PoS Node, and keep it active until August 12th. If you deactivate the delegation during the campaign time, it is not qualified to receive the rewards.</p></div>
          <div><b>●</b> <p>The top 100 delegators with biggest active staking amount will win the prize. The rewards is supported by <a href="/staking-fund" target="_blank"> $10,000 staking fund</a>.</p></div>
          <div><b>●</b> <p>Join our <a href="https://t.me/CoinpayuStaking" target="_blank"> telegram group </a> for more details.</p></div>
        </div>
        <div class="rewards-guide-model-msg-btn">
          <span @click="windowOpen('/solana-staking')">Solana staking guide <i class="fa fa-angle-right" aria-hidden="true"></i></span>
          <span @click="windowOpen('https://article.coinpayu.com/@Coinpayu/how-to-track-and-reward-solana-delegators-QN96FRDB')">How we track and reward Solana delegators? <i class="fa fa-angle-right" aria-hidden="true"></i></span>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import pageloading from '../components/pageLoading/index.vue'
export default{
  data () {
    return {
      rewradsList: [],
      loadingShow: true,
      guideShow: false,
      pointTipShow: false,
      timeAll: 0,
      time: '',
      timer: null,
      title: 'Solana staking rewards 01',
      popup: 0,
      last_id: 0,
      next_id: 0,
      sum: '',
      balance: ''
    }
  },
  components: {
    pageloading
  },
  created () {
    this.getData()
  },
  mounted () {
    document.onclick = () => {
      this.pointTipShow = false
    }
  },
  destroyed () {
    clearInterval(this.timer)
  },
  methods: {
    checkData: function (id) {
      this.pointShow = false
      this.guideShow = false
      this.getData(id)
    },
    getData: function (id) {
      this.loadingShow = true
      clearInterval(this.timer)
      this.post('/contest/stakingrewards', {coin_type: 12, id: id}).then((res) => {
        if (res.code === 200) {
          this.loadingShow = false
          this.timeAll = res.data.left_time
          this.popup = res.data.popup
          this.last_id = res.data.last_id
          this.next_id = res.data.next_id
          this.timer = setInterval(() => {
            if (this.timeAll === 0) {
              clearInterval(this.timer)
              this.time = 'Completed'
            } else {
              this.timeAll -= 1
              this.time = this.countTime(this.timeAll)
            }
          }, 1000)
          this.rewradsList = res.data.rewards
        }
      }).catch((err) => {
        console.log(err)
      })
    },
    windowOpen: function (url) {
      window.open(url, '_blank')
    },
    windowToUrl: function (url) {
      window.open(url, '_self')
    },
    toUrl: function (url) {
      if (url === this.$route.path) return
      this.$router.push(url)
    },
    countTime: function (time) {
      let d = parseInt(time / 60 / 60 / 24)
      d = d < 10 ? '0' + d : d
      let h = parseInt(time / 60 / 60 % 24)
      h = h < 10 ? '0' + h : h
      let m = parseInt(time / 60 % 60)
      m = m < 10 ? '0' + m : m
      let s = parseInt(time % 60)
      s = s < 10 ? '0' + s : s
      return d + ' : ' + h + ' : ' + m + ' : ' + s
    }
  },
  metaInfo () {
    return {
      title: 'Solana Staking Rewards 01',
      meta: [
        {
          name: 'description',
          content: 'Staking your solana to PoS Node, and win a prize.'
        }
      ]
    }
  }
}
</script>

<style scoped>
.point-active{
  color: #2FA427 !important;
}
.rewards{
  padding: 50px 20px 90px 20px;
}
.rewards-coin{
  display: flex;
  justify-content: center;
  align-items: center;
}
.rewards-coin i{
  width: 26px;
  height: 26px;
  background: #E8E8E8;
  border-radius: 50%;
  font-size: 20px;
  text-align: center;
  line-height: 26px;
  cursor: pointer;
}
.rewards-coin span{
  margin: 0 40px;
  font-size: 36px;
  font-family: 'FRAHV';
  font-weight: 400;
  color: #303030;
}
.rewards-coin-btn {
  margin: 20px 0;
  padding-left: 20px;
  text-align: center;
}
.rewards-coin-btn p{
  padding: 0 20px;
  margin-bottom: 20px;
  font-size: 30px;
  color: #2fa427;
  font-family: 'FRAHV';
}
.rewards-coin-btn span{
  display: block;
  width: 210px;
  height: 38px;
  font-size: 18px;
  font-family: Arial;
  font-weight: 400;
  color: #1D4F19;
  background: #CAE9C8;
  border-radius: 20px;
  margin-right: 10px;
  cursor: pointer;
  margin: 0 auto;
  line-height: 38px;
  text-align: center;
}
.rewards-scroll{
  max-width: 1257px;
  min-height: 700px;
  margin: 0 auto;
  overflow-x: auto;
}
.rewards-list{
  max-width: 1257px;
  min-width: 1150px;
  border-radius: 32px;
}
.rewards-list-header{
  background-color: #2FA427;
  display: flex;
  height: 90px;
  align-items: center;
  border-radius: 32px 32px 0 0;
}
.rewards-list-header div{
  text-align: center;
  font-size: 20px;
  font-family: Arial;
  font-weight: 400;
  color: #FFFFFF;
  margin: 0 10px;
}
.rewards-prize-link img{
  width: 20px;
  cursor: pointer;
}
.rewards-list-header div:nth-of-type(1){
  width: 100px;
}
.rewards-list-header div:nth-of-type(2){
 width: 60px;
}
.rewards-list-header div:nth-of-type(3){
  flex: 1;
}
.rewards-list-header div:nth-of-type(4){
  flex: 1;
}
.rewards-list-header div:nth-of-type(5){
   width: 160px;
}
.rewards-list-header div:nth-of-type(6){
  width: 160px;
}
.rewards-list-header div:nth-of-type(7){
 width: 110px;
}
.rewards-list ul{
  width: 100%;
  margin: 0;
  border-radius: 0 0 32px 32px;
  overflow: hidden;
}
.rewards-list ul li{
  display: flex;
  align-items: center;
  padding: 20px 0;
}
.rewards-list ul li div{
  font-size: 18px;
  font-family: Arial;
  font-weight: 400;
  color: #3D433D;
  text-align: center;
  overflow-x: auto;
  overflow-y: hidden;
  margin: 0 10px;
}
.rewards-list ul li div a{
  color: #0B5F04;
}
.rewards-list ul li div::-webkit-scrollbar{
  display: none;
}
.rewards-list ul li:nth-child(odd) {
  background-color: #FFFFFF;
}
.rewards-list ul li:nth-child(even) {
  background-color: #EEF4ED;
}
.rewards-list ul li div:nth-of-type(1){
  width: 100px;
}
.rewards-list ul li div:nth-of-type(2){
 width: 60px;
}
.rewards-list ul li div:nth-of-type(3){
  flex: 1;
}
.rewards-list ul li div:nth-of-type(4){
  flex: 1;
}
.rewards-list ul li div:nth-of-type(5){
   width: 160px;
}
.rewards-list ul li div:nth-of-type(6){
  width: 160px;
}
.rewards-list ul li div:nth-of-type(7){
 width: 110px;
}
.rewards-guide-model,.rewards-point-model{
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.4);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
}
.rewards-guide-model-box{
  max-width: 600px;
  width: 100%;
  background: #FFFFFF;
  border-radius: 40px;
  padding: 30px 40px;
}
.rewards-guide-model-header{
  text-align: right;
}
.rewards-guide-model-header span{
  display: inline-block;
  width: 27px;
  height: 27px;
  border: 1px solid #666666;
  border-radius: 50%;
  text-align: center;
  line-height: 27px;
  cursor: pointer;
}
.rewards-guide-model h4{
  font-family: 'PingFangSC-Medium';
  font-weight: 800;
  color: #303030;
  font-size: 20px;
}
.rewards-guide-model-msg{
  margin-top: 30px;
}
.rewards-guide-model-msg div{
  font-size: 16px;
  font-family: 'PingFangSC-Medium';
  font-weight: 500;
  color: #303030;
  display: flex;
  margin-bottom: 18px;
}
.rewards-guide-model-msg div b{
  margin: 3px 10px 0 0;
  font-size: 5px;
}
.rewards-guide-model-msg p a{
  text-decoration: underline #0B5F04;
  color: #0B5F04;
}
.rewards-guide-model-msg-btn{
  margin-top: 20px;
}
.rewards-guide-model-msg-btn span{
  padding: 5px 10px;
  font-size: 16px;
  font-family: Arial;
  font-weight: 400;
  color: #1D4F19;
  background: #CAE9C8;
  border-radius: 16px;
  margin: 0px 10px 8px 0;
  display: inline-block;
  cursor: pointer;
}
.rewards-point-model-tip{
  position: relative;
}
.rewards-point-model-tip p img{
  width: 20px;
  height: 20px;
  cursor: pointer;
}
.rewards-point-model-tip div.rewards-point-model-tip-content{
  position: absolute;
  right: 0px;
  top: 30px;
  width: 235px;
  background: #E7E7E7;
  padding: 17px;
  z-index: 99;
  border-radius: 3px;
  font-size: 14px;
  font-family: Arial;
  font-weight: 400;
  color: #666666;
}
</style>



// WEBPACK FOOTER //
// src/pages/solana_reward.vue